import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../shared.module';
import { EditComponent } from './components/edit/edit.component';
import { ListComponent } from './pages/list/list.component';

const routes: Routes = [
  {
    path: '',
    component: ListComponent,
    data: { animation: 'isLeft' },
  },
];

@NgModule({
  declarations: [ListComponent, EditComponent],
  imports: [RouterModule.forChild(routes), SharedModule],
  exports: [ListComponent, EditComponent],
})
export class MasterVehiclesModule {}
